import {
  PaginatedData,
  Participant,
  ParticipantSection,
} from "@app/types/interfaces";
import { api } from "@app/api";

const participantPath = "/records/participant";
const participantSectionPath = "/records/participant_section";

const participantQueryParams = {
  datafy_fields:
    "id,course,user,sections.id,sections.section,sections.status,progress,duration,tests.id,tests.status,tests.score,tests.test,tests.participant_answers.id,tests.participant_answers.answer,tests.participant_answers.participant_test",
};

export const getParticipantsOfUserId = (
  userId: string
): Promise<PaginatedData<Participant>> => {
  return api.get(`${participantPath}?user__eq=${userId}`, {
    params: participantQueryParams,
  });
};

export const createParticipant = (newParticipant: Participant) => {
  return api.post<void, Participant>(`${participantPath}`, newParticipant);
};

export const setParticipantSection = (
  participantSection: ParticipantSection
) => {
  return api.post<void, ParticipantSection>(
    `${participantSectionPath}`,
    participantSection
  );
};

export const bulkDeleteParticipantSections = (queryParams) => {
  return api.delete<void, void>(`${participantSectionPath}/bulk`, {
    params: queryParams,
  });
};

export const setParticipantSectionForNewlyStaredCourse = (
  section: ParticipantSection
) => {
  return api.post<void, ParticipantSection>(
    `${participantSectionPath}`,
    section
  );
};

export const updateStatusOfParticipantService = (
  pSectionId: number,
  status: string
) => {
  return api.patch<void, ParticipantSection>(
    `${participantSectionPath}/${pSectionId}`,
    {
      status,
    }
  );
};

export const updateParticipantProgress = (
  participantId: number,
  duration: number,
  progress: number
) => {
  return api.patch<void, Participant>(`${participantPath}/${participantId}`, {
    duration,
    progress,
  });
};

export const getParticipant = (
  courseId: number,
  userId: string
): Promise<PaginatedData<Participant>> => {
  return api.get(
    `${participantPath}?course__eq=${courseId}&user__eq=${userId}`,
    {
      params: participantQueryParams,
    }
  );
};
